'use client';

import { useEffect } from 'react';
import { useStore } from 'zustand';

import { authStore } from '@/store/auth.store';
import { ensureCartLoaded } from '@/store/cart/cart.store';

export function useEnsureCartLoaded(): void {
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    void ensureCartLoaded();
  }, [isLoggedIn]);
}
